webpackJsonp([8],{

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(469),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1214da69",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDlDMTYuNTUyMyA5IDE3IDguNTUyMjggMTcgOEMxNyA3LjQ0NzcyIDE2LjU1MjMgNyAxNiA3TDE2IDlaTTAuMjkyODkzIDcuMjkyODlDLTAuMDk3NjMxIDcuNjgzNDIgLTAuMDk3NjMxMSA4LjMxNjU4IDAuMjkyODkzIDguNzA3MTFMNi42NTY4NSAxNS4wNzExQzcuMDQ3MzggMTUuNDYxNiA3LjY4MDU0IDE1LjQ2MTYgOC4wNzEwNyAxNS4wNzExQzguNDYxNTkgMTQuNjgwNSA4LjQ2MTU5IDE0LjA0NzQgOC4wNzEwNyAxMy42NTY5TDIuNDE0MjEgOEw4LjA3MTA3IDIuMzQzMTVDOC40NjE1OSAxLjk1MjYyIDguNDYxNTkgMS4zMTk0NiA4LjA3MTA3IDAuOTI4OTMxQzcuNjgwNTQgMC41Mzg0MDcgNy4wNDczOCAwLjUzODQwNyA2LjY1Njg1IDAuOTI4OTMxTDAuMjkyODkzIDcuMjkyODlaTTE2IDdMMSA3TDEgOUwxNiA5TDE2IDdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgN0MwLjQ0NzcxNSA3IDAgNy40NDc3MiAwIDhDMCA4LjU1MjI4IDAuNDQ3NzE1IDkgMSA5VjdaTTE2LjcwNzEgOC43MDcxMUMxNy4wOTc2IDguMzE2NTggMTcuMDk3NiA3LjY4MzQyIDE2LjcwNzEgNy4yOTI4OUwxMC4zNDMxIDAuOTI4OTMyQzkuOTUyNjIgMC41Mzg0MDggOS4zMTk0NiAwLjUzODQwOCA4LjkyODkzIDAuOTI4OTMyQzguNTM4NDEgMS4zMTk0NiA4LjUzODQxIDEuOTUyNjIgOC45Mjg5MyAyLjM0MzE1TDE0LjU4NTggOEw4LjkyODkzIDEzLjY1NjlDOC41Mzg0MSAxNC4wNDc0IDguNTM4NDEgMTQuNjgwNSA4LjkyODkzIDE1LjA3MTFDOS4zMTk0NiAxNS40NjE2IDkuOTUyNjIgMTUuNDYxNiAxMC4zNDMxIDE1LjA3MTFMMTYuNzA3MSA4LjcwNzExWk0xIDlIMTZWN0gxVjlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(229)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40a2ff84",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiByeD0iMzAiIGZpbGw9IiM1NTU1RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMS40MjM4IDE3LjU2ODFDMzEuNzc1MiAxNy43MzI2IDMxLjk5OTcgMTguMDg1NiAzMS45OTk3IDE4LjQ3MzZWNDIuMTU3OUMzMS45OTk3IDQyLjU0NTkgMzEuNzc1MiA0Mi44OTg5IDMxLjQyMzggNDMuMDYzNEMzMS4wNzI1IDQzLjIyOCAzMC42NTc2IDQzLjE3NDUgMzAuMzU5NSA0Mi45MjYxTDIyLjc0MjkgMzYuNTc4OUgyMC40NzM0QzE4LjQ2NzcgMzYuNTc4OSAxNi44NDE4IDM0Ljk1MyAxNi44NDE4IDMyLjk0NzNWMjcuNjg0MkMxNi44NDE4IDI1LjY3ODUgMTguNDY3NyAyNC4wNTI2IDIwLjQ3MzQgMjQuMDUyNkgyMi43NDI5TDMwLjM1OTUgMTcuNzA1NEMzMC42NTc2IDE3LjQ1NyAzMS4wNzI1IDE3LjQwMzUgMzEuNDIzOCAxNy41NjgxWk0zOC4xODczIDIxLjcxMzlDMzguNTc3OCAyMS4zMjM0IDM5LjIxMSAyMS4zMjM0IDM5LjYwMTUgMjEuNzEzOUM0MS44NTc0IDIzLjk2OTggNDIuNTI2IDI3LjU5MjQgNDIuNTI2IDMwLjMxNThDNDIuNTI2IDMzLjAzOTEgNDEuODU3NCAzNi42NjE3IDM5LjYwMTUgMzguOTE3NkMzOS4yMTEgMzkuMzA4MSAzOC41Nzc4IDM5LjMwODEgMzguMTg3MyAzOC45MTc2QzM3Ljc5NjggMzguNTI3MSAzNy43OTY4IDM3Ljg5MzkgMzguMTg3MyAzNy41MDM0QzM5Ljg3ODggMzUuODExOSA0MC41MjYgMzIuODU1NSA0MC41MjYgMzAuMzE1OEM0MC41MjYgMjcuNzc2IDM5Ljg3ODggMjQuODE5NiAzOC4xODczIDIzLjEyODFDMzcuNzk2OCAyMi43Mzc2IDM3Ljc5NjggMjIuMTA0NCAzOC4xODczIDIxLjcxMzlaTTM0LjI0IDI1LjY2MTJDMzQuNjMwNSAyNS4yNzA3IDM1LjI2MzcgMjUuMjcwNyAzNS42NTQyIDI1LjY2MTNDMzYuNTMyOCAyNi41Mzk5IDM3LjI2MjggMjguMTI3OCAzNy4yNjI4IDMwLjMxNThDMzcuMjYyOCAzMi41MDM3IDM2LjUzMjggMzQuMDkxNiAzNS42NTQyIDM0Ljk3MDJDMzUuMjYzNiAzNS4zNjA3IDM0LjYzMDUgMzUuMzYwNyAzNC4yNCAzNC45NzAyQzMzLjg0OTQgMzQuNTc5NyAzMy44NDk0IDMzLjk0NjUgMzQuMjQgMzMuNTU2QzM0LjY3NzEgMzMuMTE4OSAzNS4yNjI4IDMyLjA3NTIgMzUuMjYyOCAzMC4zMTU4QzM1LjI2MjggMjguNTU2MyAzNC42NzcxIDI3LjUxMjYgMzQuMjM5OSAyNy4wNzU1QzMzLjg0OTQgMjYuNjg0OSAzMy44NDk0IDI2LjA1MTggMzQuMjQgMjUuNjYxMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return settingsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);




var getSettings = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var settings;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!window.localStorage.engsettings) {
              _context.next = 6;
              break;
            }

            settings = JSON.parse(window.localStorage.engsettings);

            console.log("GOT SETTINGS FROM LOCALSTORAGE");

            return _context.abrupt("return", settings);

          case 6:
            console.log("WAS MADE");
            window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([true, true]));

          case 8:
            return _context.abrupt("return", [true, true]);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getSettings() {
    return _ref.apply(this, arguments);
  };
}();

var setSettings = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(newsetting) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (window.localStorage.engsettings) {
              window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newsetting));
            } else {
              window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([true, true]));
            }

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function setSettings(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var settingsService = {
  getSettings: getSettings,
  setSettings: setSettings
};

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(220)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(223),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-245f8eaa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(236),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArrowIconPath; });
var getArrowIconPath = function getArrowIconPath(languageDirection) {

    var arrowIconNext = void 0;
    var arrowIconPrevious = void 0;

    if (languageDirection === 'rtl') {
        arrowIconNext = __webpack_require__(205).default;
        arrowIconPrevious = __webpack_require__(206).default;
    } else {
        arrowIconNext = __webpack_require__(206).default;
        arrowIconPrevious = __webpack_require__(205).default;
    }

    return {
        arrowIconNext: arrowIconNext,
        arrowIconPrevious: arrowIconPrevious
    };
};

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(217);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("f5ffd5f0", content, true, {});

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.VideoPlayer iframe {\n  width: 100%;\n  max-height: 600px;\n  max-width: 800px;\n  /* height: 100%; */\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/VideoPlayer.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;CACpB","file":"VideoPlayer.vue","sourcesContent":["\n.VideoPlayer iframe {\n  width: 100%;\n  max-height: 600px;\n  max-width: 800px;\n  /* height: 100%; */\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    vidSrc: {
      default: ""
    }
  },
  data: function data() {
    return {
      height: "250px"
    };
  },
  mounted: function mounted() {
    // setTimeout(() => {
    //   this.height = (this.$refs.videoIframe.clientWidth / 16) * 9 + "px";
    //   console.log(this.height);
    // }, 2000);
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VideoPlayer"
  }, [_c('iframe', {
    ref: "videoIframe",
    attrs: {
      "src": _vm.vidSrc,
      "height": _vm.height,
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(221);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("7be071af", content, true, {});

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n@-webkit-keyframes spin {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n@keyframes spin-data-v-245f8eaa {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n.slinky-loader[data-v-245f8eaa] {\n  position: relative;\n  margin-top: 20px;\n  width: 40px;\n  aspect-ratio: 1;\n  border: 5px solid #555fff;\n  -webkit-animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n          animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n  border-radius: 50%;\n}\n.slinky-loader[data-v-245f8eaa]::after {\n  position: absolute;\n  content: \"\";\n  width: 30%;\n  aspect-ratio: 1;\n  top: 50%;\n  left: 100%;\n  -webkit-transform: translate(-25%, -50%);\n          transform: translate(-25%, -50%);\n  background: white;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/Slinky.vue"],"names":[],"mappings":";AACA;AACA;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;AACA;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,sEAAsE;UAC9D,8DAA8D;EACtE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,yCAAyC;UACjC,iCAAiC;EACzC,kBAAkB;CACnB","file":"Slinky.vue","sourcesContent":["\n@-webkit-keyframes spin {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n@keyframes spin-data-v-245f8eaa {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n.slinky-loader[data-v-245f8eaa] {\n  position: relative;\n  margin-top: 20px;\n  width: 40px;\n  aspect-ratio: 1;\n  border: 5px solid #555fff;\n  -webkit-animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n          animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n  border-radius: 50%;\n}\n.slinky-loader[data-v-245f8eaa]::after {\n  position: absolute;\n  content: \"\";\n  width: 30%;\n  aspect-ratio: 1;\n  top: 50%;\n  left: 100%;\n  -webkit-transform: translate(-25%, -50%);\n          transform: translate(-25%, -50%);\n  background: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Slinky"
});

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slinky-loader"
  })
},staticRenderFns: []}

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(228);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("341b2bf2", content, true, {});

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "#progressBar{position:relative;top:-7px}.slider::-moz-range-thumb{width:20px;height:20px;border-radius:50%;background:#555fff;cursor:pointer}.slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:20px;height:20px;background:#555fff;border-radius:50%;cursor:pointer}.disabledBtn{display:none}.audio-player-container{display:flex;align-items:center;justify-content:center;gap:8px}.speed-btn{background:var(--bg-primary, #555fff);color:#fff;border:none;border-radius:16px;padding:4px 8px;font-size:12px;font-weight:500;min-width:36px;height:24px;cursor:pointer;transition:all .2s ease;user-select:none}.speed-btn:hover{background:var(--bg-primary-hover, #4444ee);transform:scale(1.05)}.speed-btn:active{transform:scale(0.95)}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/AudioPlayer.scss"],"names":[],"mappings":"AAAA,aACE,kBAEA,QAAA,CAGF,0BACE,WACA,YACA,kBAEA,mBACA,cAAA,CAGF,8BACE,wBACA,gBACA,WACA,YACA,mBACA,kBACA,cAAA,CA4DF,aACE,YAAA,CAGF,wBACE,aACA,mBACA,uBACA,OAAA,CAGF,WACE,sCACA,WACA,YACA,mBACA,gBACA,eACA,gBACA,eACA,YACA,eACA,wBACA,gBAAA,CAEA,iBACE,4CACA,qBAAA,CAGF,kBACE,qBAAA,CAAA","file":"AudioPlayer.scss","sourcesContent":["#progressBar {\n  position: relative;\n  // top: -9px;\n  top: -7px;\n}\n\n.slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n\n  background: #555fff;\n  cursor: pointer;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  background: #555fff;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n// input[type=\"range\"] {\n//   -webkit-appearance: none;\n//   // margin-right: 15px;\n//   width: 120px;\n//   height: 7px;\n//   background: #aaabbb;\n//   border-radius: 5px;\n//   background-position: right center;\n//   background-image: linear-gradient(#7070af, #111199);\n//   background-size: 0% 100%;\n//   background-repeat: no-repeat;\n// }\n\n// input[type=\"range\"]::-webkit-slider-thumb {\n//   -webkit-appearance: none;\n//   height: 15px;\n//   width: 15px;\n//   border-radius: 50%;\n//   background: #555fff;\n//   cursor: ew-resize;\n//   box-shadow: 0 0 2px 0 #555;\n//   transition: background 0.3s ease-in-out;\n// }\n\n// input[type=\"range\"]::-moz-range-thumb {\n//   -webkit-appearance: none;\n//   height: 15px;\n//   width: 15px;\n//   border-radius: 50%;\n//   background: #555fff;\n//   cursor: ew-resize;\n//   box-shadow: 0 0 2px 0 #390b8d;\n//   transition: background 0.3s ease-in-out;\n// }\n\n// input[type=\"range\"]::-webkit-slider-runnable-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: transparent;\n// }\n\n// input[type=\"range\"]::-moz-range-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: transparent;\n// }\n\n// NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE\n// .slider::-webkit-slider-runnable-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: blue;\n// }\n\n.disabledBtn {\n  display: none;\n}\n\n.audio-player-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.speed-btn {\n  background: var(--bg-primary, #555fff);\n  color: white;\n  border: none;\n  border-radius: 16px;\n  padding: 4px 8px;\n  font-size: 12px;\n  font-weight: 500;\n  min-width: 36px;\n  height: 24px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n  \n  &:hover {\n    background: var(--bg-primary-hover, #4444ee);\n    transform: scale(1.05);\n  }\n  \n  &:active {\n    transform: scale(0.95);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(230);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("2144f390", content, true, {});

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.noaudio[data-v-40a2ff84] {\n  min-width: 40px;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/audioBtn.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB","file":"audioBtn.vue","sourcesContent":["\n.noaudio[data-v-40a2ff84] {\n  min-width: 40px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audioBtn_scss__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audioBtn_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__audioBtn_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_audioService__ = __webpack_require__(76);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "audio-btn",
  props: {
    urlId: {
      type: String | Number,
      require: true
    },
    height: {
      type: Number,
      default: 50
    },
    autoplay: {
      type: Boolean,
      deafult: false
    },
    idx: {
      type: Number,
      default: 0
    },
    display: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      audioSrc: "",
      isStop: null,
      showError: false
    };
  },
  created: function created() {
    this.getAudio();
  },

  watch: {
    urlId: function urlId() {
      if (this.idx) return;
      this.isStop = true;
      this.getAudio();
    },
    idx: function idx() {
      this.isStop = true;
      this.getAudio();
    },
    autoplay: function autoplay() {
      if (this.autoplay) this.playAudio();
    }
  },
  methods: {
    getAudio: function getAudio() {
      var _this = this;

      console.log(this.autoplay);
      if (this.urlId) {
        __WEBPACK_IMPORTED_MODULE_3__services_audioService__["a" /* audioService */].playAudio(this.urlId).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
            var _ref2, sound_file;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return res.json();

                  case 2:
                    _ref2 = _context.sent;
                    sound_file = _ref2.sound_file;

                    _this.audioSrc = sound_file;
                    if (_this.autoplay && _this.audioSrc) {
                      // this.isStop = false;
                      _this.playAudio();
                    }

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } else {
        this.audioSrc = null;
      }
    },
    playAudio: function playAudio(ev) {
      var _this2 = this;

      if (ev) {
        ev.stopPropagation();
      }
      if (this.$store.getters.isPlaying) {
        setTimeout(function () {}, 1500);
      }
      var audio = new Audio(this.audioSrc);
      document.getElementById('speaker-svg').classList.add("is-playing");
      this.$store.commit("setIsPlaying", true);
      audio.play().then(this.$store.commit("setIsPlaying", false)).catch(function (e) {
        console.log(e);
        _this2.$store.commit("setError", e);
        _this2.$store.commit("setIsPlaying", false);
      });
      document.getElementById('speaker-svg').classList.remove("is-playing");
    }
  },
  updated: function updated() {
    console.log("audio is updated");
  },
  destroyed: function destroyed() {
    this.isStop = true;
  },

  components: {}
});

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(233);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("5ddadbf4", content, true, {});

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".audio-btn{cursor:pointer;position:relative}.audio .audio-btn{width:28px !important;aspect-ratio:1/1}.audio .audio-btn svg{width:100%;height:100%}.speaker-svg{width:60px;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}.is-playing{box-shadow:0 0 10px 6px var(--bubble-bg-selected);border-radius:50%}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/audioBtn.scss","/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/scss/abstracts/_mixins.scss"],"names":[],"mappings":"AAGA,WACE,eACA,iBAAA,CAGF,kBACE,sBACA,gBAAA,CAGF,sBACE,WACA,WAAA,CAGF,aACE,WClBA,kBACA,QACA,SACA,+BAAA,CDmBF,YACE,kDACA,iBAAA,CAAA","file":"audioBtn.scss","sourcesContent":["@import \"../../scss/abstracts/variables\";\n@import \"../../scss/abstracts/mixins\";\n\n.audio-btn {\n  cursor: pointer;\n  position: relative;\n}\n\n.audio .audio-btn {\n  width: 28px !important;\n  aspect-ratio: 1/1;\n}\n\n.audio .audio-btn svg {\n  width: 100%;\n  height: 100%;\n}\n\n.speaker-svg {\n  width: 60px;\n  @include absCenter;\n\n}\n.is-playing {\n  box-shadow: 0 0 10px 6px var(--bubble-bg-selected);\n  border-radius: 50%;\n}","@mixin absCenter {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n//media query\n//1em=16px\n// em and rem in media query always equall fs from browser =16px unless user change it.\n//rem failed work with some of browrswers\n@mixin respon($breakpoint) {\n  @if $breakpoint==no-phone {\n    @media (min-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==phone {\n    @media (max-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==700px {\n    @media (max-width: 43.75em) {\n      //700px\n      @content;\n    }\n  }\n  @if $breakpoint==tab-port {\n    @media (max-width: 56.25em) {\n      //900px\n      @content;\n    }\n  }\n\n  @if $breakpoint==tab-land {\n    @media (max-width: 75em) {\n      //1200px\n      @content;\n    }\n  }\n  @if $breakpoint==big-desktop {\n    //1800px\n    @media (min-width: 112.5em) {\n      @content;\n    }\n  }\n}\n\n@mixin aspect-ratio($width, $height) {\n  position: relative;\n  overflow: hidden;\n  &:before {\n    display: block;\n    content: \"\";\n    width: 100%;\n    padding-top: ($height / $width) * 100%;\n  }\n  > * {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n  }\n\n  > img {\n    object-fit: cover;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.audioSrc) ? _c('button', {
    staticClass: "audio-btn",
    style: ({
      height: _vm.height + 'px',
      width: _vm.height + 'px',
      display: _vm.display ? 'inline-block' : 'none'
    }),
    on: {
      "click": _vm.playAudio
    }
  }, [_c('audio', [_c('source', {
    attrs: {
      "src": _vm.audioSrc,
      "type": "audio/mp3"
    }
  })]), _vm._v(" "), _c('inline-svg', {
    staticClass: "speaker-svg",
    attrs: {
      "id": "speaker-svg",
      "src": __webpack_require__(208).default,
      "aria-label": "My image"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.audioSrc) ? _c('div', {
    staticClass: "noaudio"
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    height: { type: String, required: true }
  }
});

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      height: (_vm.height + "px")
    })
  })
},staticRenderFns: []}

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMCAyMiI+PGRlZnM+PHN0eWxlPi5sZXNzb24tY2xzLTF7ZmlsbDojZmY1NTgzO30ubGVzc29uLWNscy0ye2ZpbGw6bm9uZTtzdHJva2U6IzZhMDkyMztzdHJva2Utd2lkdGg6MnB4O30ubGVzc29uLWNscy0ze2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48ZyBpZD0iR3JvdXBfMjQxIiBkYXRhLW5hbWU9Ikdyb3VwIDI0MSI+PGcgaWQ9IlJlY3RhbmdsZV82NzYiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDY3NiI+PHJlY3QgY2xhc3M9Imxlc3Nvbi1jbHMtMSIgd2lkdGg9IjMwIiBoZWlnaHQ9IjIyIiByeD0iNCIvPjxyZWN0IGNsYXNzPSJsZXNzb24tY2xzLTIiIHg9IjEiIHk9IjEiIHdpZHRoPSIyOCIgaGVpZ2h0PSIyMCIgcng9IjMiLz48L2c+PHBhdGggaWQ9IlBvbHlnb25fNTciIGRhdGEtbmFtZT0iUG9seWdvbiA1NyIgY2xhc3M9Imxlc3Nvbi1jbHMtMyIgZD0iTTE2LjE0LDcuMTJhMSwxLDAsMCwxLDEuMzcuMzYsMSwxLDAsMCwxLC4xNC41MWwwLDYuNmExLDEsMCwwLDEtMS41Ljg2bC01LjY3LTMuMjdhMSwxLDAsMCwxLS4zNy0xLjM3LDEsMSwwLDAsMSwuMzYtLjM3WiIvPjwvZz48L2c+PC9nPjwvc3ZnPg==");

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(286)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(291),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-486302e7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(287);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("13cbb262", content, true, {});

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.backarrowDiv[data-v-486302e7] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 50px;\n  height: 50px;\n}\n.arrow-svg-lesson[data-v-486302e7] {\n  margin: auto;\n}\n.noShow[data-v-486302e7] {\n  opacity: 0;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Lesson/lesson-header.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,aAAa;CACd;AACD;EACE,aAAa;CACd;AACD;EACE,WAAW;CACZ","file":"lesson-header.vue","sourcesContent":["\n.backarrowDiv[data-v-486302e7] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 50px;\n  height: 50px;\n}\n.arrow-svg-lesson[data-v-486302e7] {\n  margin: auto;\n}\n.noShow[data-v-486302e7] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lesson_header_scss__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lesson_header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lesson_header_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_svgConfig__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(78);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "lesson-header",
  props: ["currentData", "outerData", "externalType"],
  data: function data() {
    return {
      lessonName: "",
      arrowIconPath: {
        arrowIconNext: "",
        arrowIconPrevious: ""
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.arrowIconPath = Object(__WEBPACK_IMPORTED_MODULE_3__utils_svgConfig__["a" /* getArrowIconPath */])(localStorage.getItem("srcDirection"));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    currentData: function currentData() {
      this.lessonName = this.currentData ? this.currentData.name : "";
    }
  },
  mounted: function mounted() {
    this.lessonName = this.currentData ? this.currentData.name : "";
  },

  methods: {
    prevChapter: function prevChapter(event) {
      console.log("VLIVK");
      if (this.externalType === "grammar" || this.externalType === "sentence") this.$emit("closeIntro", "ok");

      if (!this.externalType) this.$router.push({
        path: "/chapter/"
      });
    }
  },
  components: {}
});

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(290);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("656b7fdf", content, true, {});

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".lesson-header{display:grid;justify-content:space-between;background-color:var(--header-primary);height:60px;grid-template-columns:15% 1fr 15%;align-items:center;justify-items:center}.lesson-header h2{text-align:center;font:var(--medium-font)}.lesson-header h6{text-align:center;font:var(--medium-font);color:var(--button-primary-text)}.lesson-titles{display:flex;flex-direction:column;align-items:center;justify-content:space-between}.cup-svg{width:35px;height:35px}.arrow-svg-lesson{height:30px;aspect-ratio:1/1;fill:var(--button-primary-text)}.disabled{fill:var(--color-disabled)}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Lesson/src/components/Lesson/lesson-header.scss"],"names":[],"mappings":"AAEA,eACE,aACA,8BACA,uCACA,YACA,kCACA,mBACA,oBAAA,CAEA,kBACE,kBACA,uBAAA,CAEF,kBACE,kBACA,wBACA,gCAAA,CAIJ,eACE,aACA,sBACA,mBACA,6BAAA,CAGF,SACE,WACA,WAAA,CAEF,kBACE,YACA,iBACA,+BAAA,CAGF,UACE,0BAAA,CAAA","file":"lesson-header.scss","sourcesContent":["@import \"../../scss//abstracts/variables\";\n\n.lesson-header {\n  display: grid;\n  justify-content: space-between;\n  background-color: var(--header-primary);\n  height: 60px;\n  grid-template-columns: 15% 1fr 15%;\n  align-items: center;\n  justify-items: center;\n\n  h2 {\n    text-align: center;\n    font: var(--medium-font);\n  }\n  h6 {\n    text-align: center;\n    font: var(--medium-font);\n    color: var(--button-primary-text);\n  }\n}\n\n.lesson-titles {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.cup-svg {\n  width: 35px;\n  height: 35px;\n}\n.arrow-svg-lesson {\n  height: 30px;\n  aspect-ratio: 1/1;\n  fill: var(--button-primary-text);\n}\n\n.disabled {\n  fill: var(--color-disabled);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lesson-header"
  }, [_c('div', {
    staticClass: "backarrowDiv",
    on: {
      "click": _vm.prevChapter
    }
  }, [_c('inline-svg', {
    staticClass: "arrow-svg-lesson",
    attrs: {
      "src": _vm.arrowIconPath.arrowIconPrevious
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "lesson-titles"
  }, [(_vm.currentData) ? _c('h2', [_vm._v("\n      " + _vm._s(_vm.currentData.courseName) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.currentData) ? _c('h6', [_vm._v("\n      " + _vm._s(_vm.lessonName ? _vm.lessonName : "") + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.outerData) ? _c('h6', [_vm._v("\n      " + _vm._s(_vm.outerData ? _vm.outerData : "") + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('inline-svg', {
    staticClass: "cup-svg",
    class: {
      noShow: _vm.outerData
    },
    attrs: {
      "src": __webpack_require__(237).default
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(458);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("25d9765f", content, true, {});

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".modal{display:flex;flex-direction:column;align-items:center;justify-content:start;text-align:center;background-color:var(--bg-primary);opacity:1;padding:12px;border-radius:4px}.centered{text-align:center;overflow:scroll;font:var(--large-font);display:flex;flex-direction:column;justify-content:space-between}#img{width:100%;height:auto}.hide{display:none}.lesson-page{height:100vh;display:flex;flex-direction:column;justify-content:space-between}.lesson-page .lesson-player{position:sticky;top:0;padding:.5em 0;background:var(--header-secondary);color:var(--bg-primary)}.lesson-page .lesson-player input[type=range]{-webkit-appearance:none;appearance:none;background:var(--header-primary);cursor:pointer;border-radius:3px;height:6px;width:50%;box-shadow:0px 0px 4px 0px hsla(0,0%,100%,.25)}.lesson-page .lesson-player input[type=range]:focus{outline:none}.lesson-page .lesson-player input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;background-color:var(--bg-primary);height:1em;width:1em;box-shadow:4px 4px 0px rgba(0,0,0,.25)}.lesson-page .lesson-player input[type=range]:focus::-webkit-slider-thumb{border:none;outline:none}.lesson-page .lesson-player input[type=range]::-moz-range-track{background-color:var(--bg-primary);border-radius:3px;height:6px}.lesson-page .lesson-player input[type=range]::-moz-range-thumb{border:none;border-radius:0;background-color:var(--bg-primary);height:1em;width:1em}.lesson-page .lesson-player input[type=range]:focus::-moz-range-thumb{border:1px solid var(--bg-primary);outline:3px solid var(--bg-primary);outline-offset:.125rem}.lesson-page .actions-wrapper{padding:0;height:100px;margin-top:auto;width:100%}.lesson-page .actions-wrapper .lesson-approve{width:100%;height:100%;text-align:center;justify-content:center;border-radius:unset;font:var(--huge-font);display:flex;padding:8px;color:var(--button-primary-text);background-color:var(--button-primary)}.lesson-page .actions-wrapper .lesson-approve:hover{color:var(--button-primary-text);background-color:var(--bubble-bg-selected)}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Lesson/src/components/Lesson/lesson-page.scss"],"names":[],"mappings":"AAEA,OACE,aACA,sBACA,mBACA,sBACA,kBACA,mCACA,UACA,aACA,iBAAA,CAGF,UACE,kBACA,gBACA,uBACA,aACA,sBACA,6BAAA,CAGF,KACE,WACA,WAAA,CAGF,MACE,YAAA,CAGF,aACE,aACA,aACA,sBACA,6BAAA,CAEA,4BACE,gBACA,MACA,eACA,mCACA,uBAAA,CAIA,8CACE,wBACA,gBACA,iCACA,eACA,kBACA,WACA,UACA,8CAAA,CAKF,oDACA,YAAA,CAUA,oEACA,wBACE,gBAGA,mCACA,WACA,UACA,sCAAA,CAGF,0EACA,YACA,YAAA,CAKA,gEACE,mCACA,kBACA,UAAA,CAIF,gEACE,YACA,gBAGA,mCACA,WACA,SAAA,CAGF,sEACE,mCACA,oCACA,sBAAA,CAKJ,8BACE,UACA,aACA,gBACA,UAAA,CAEA,8CACE,WACA,YACA,kBACA,uBACA,oBACA,sBACA,aACA,YACA,iCACA,sCAAA,CAEA,oDACE,iCACA,0CAAA,CAAA","file":"lesson-page.scss","sourcesContent":["@import \"../../scss//abstracts/variables\";\n\n.modal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: start;\n  text-align: center;\n  background-color: var(--bg-primary);\n  opacity: 1;\n  padding: 12px;\n  border-radius: 4px;\n}\n\n.centered {\n  text-align: center;\n  overflow: scroll;\n  font: var(--large-font);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n#img {\n  width: 100%;\n  height: auto;\n}\n\n.hide {\n  display: none;\n}\n\n.lesson-page {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  .lesson-player {\n    position: sticky;\n    top: 0;\n    padding: 0.5em 0;\n    background: var(--header-secondary);\n    color: var(--bg-primary);\n\n    /********** Range Input Styles **********/\n    /*Range Reset*/\n    input[type=\"range\"] {\n      -webkit-appearance: none;\n      appearance: none;\n      background: var(--header-primary);\n      cursor: pointer;\n      border-radius: 3px;\n      height: 6px;\n      width: 50%;\n      box-shadow: 0px 0px 4px 0px rgba(255,255,255,0.25)\n\n    }\n\n    /* Removes default focus */\n    input[type=\"range\"]:focus {\n    outline: none;\n    }\n\n    /***** Chrome, Safari, Opera and Edge Chromium styles *****/\n    /* slider track */\n    input[type=\"range\"]::-webkit-slider-runnable-track {\n      \n    }\n\n    /* slider thumb */\n    input[type=\"range\"]::-webkit-slider-thumb {\n    -webkit-appearance: none; /* Override default look */\n      appearance: none;\n\n      /*custom styles*/\n      background-color: var(--bg-primary);\n      height: 1em;\n      width: 1em;\n      box-shadow: 4px 4px 0px rgba(0,0,0,0.25)\n    }\n\n    input[type=\"range\"]:focus::-webkit-slider-thumb {   \n    border: none;\n    outline: none;\n    }\n\n    /******** Firefox styles ********/\n    /* slider track */\n    input[type=\"range\"]::-moz-range-track {\n      background-color: var(--bg-primary);\n      border-radius: 3px;\n      height: 6px;\n    }\n\n    /* slider thumb */\n    input[type=\"range\"]::-moz-range-thumb {\n      border: none; /*Removes extra border that FF applies*/\n      border-radius: 0; /*Removes default border-radius that FF applies*/\n\n      /*custom styles*/\n      background-color: var(--bg-primary);\n      height: 1em;\n      width: 1em;\n    }\n\n    input[type=\"range\"]:focus::-moz-range-thumb {\n      border: 1px solid var(--bg-primary);\n      outline: 3px solid var(--bg-primary);\n      outline-offset: 0.125rem; \n    }\n\n  }\n\n  .actions-wrapper {\n    padding: 0;\n    height: 100px;\n    margin-top: auto;\n    width: 100%;\n\n    .lesson-approve {\n      width: 100%;\n      height: 100%;\n      text-align: center;\n      justify-content: center;\n      border-radius: unset;\n      font: var(--huge-font);\n      display: flex;\n      padding: 8px;\n      color: var(--button-primary-text);\n      background-color: var(--button-primary);\n  \n      &:hover {\n        color: var(--button-primary-text);\n        background-color: var(--bubble-bg-selected);\n      }  \n    }\n  }\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(460);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("79b64d62", content, true, {});

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\nimg[data-v-1214da69] {\n  width: 90vw;\n  max-width: 500px;\n}\niframe[data-v-1214da69] {\n  height: 50vh;\n}\n.lesson-approve[data-v-1214da69] {\n  bottom: var(--bottom);\n}\n.LesonTop[data-v-1214da69] {\n  position: sticky;\n  top: var(--top);\n}\n.loader[data-v-1214da69] {\n  text-align: center;\n  margin: 30px;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Lesson/lesson-page.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,iBAAiB;CAClB;AACD;EACE,aAAa;CACd;AACD;EACE,sBAAsB;CACvB;AACD;EACE,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,mBAAmB;EACnB,aAAa;CACd","file":"lesson-page.vue","sourcesContent":["\nimg[data-v-1214da69] {\n  width: 90vw;\n  max-width: 500px;\n}\niframe[data-v-1214da69] {\n  height: 50vh;\n}\n.lesson-approve[data-v-1214da69] {\n  bottom: var(--bottom);\n}\n.LesonTop[data-v-1214da69] {\n  position: sticky;\n  top: var(--top);\n}\n.loader[data-v-1214da69] {\n  text-align: center;\n  margin: 30px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lesson_page_scss__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lesson_page_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lesson_page_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lesson_header_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lesson_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lesson_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Spacer_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Spacer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Shared_Spacer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_VideoPlayer_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_VideoPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Shared_VideoPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_audioBtn_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_audioBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Shared_audioBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_AudioPlayerLesson_vue__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_AudioPlayerLesson_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Shared_AudioPlayerLesson_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_userService__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_courseService__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_Slinky_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_Slinky_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Shared_Slinky_vue__);



var _this2 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: "lesson-page",
  props: ["data"],
  data: function data() {
    return {
      lessonImage: null,
      lessonAudio: null,
      submitting: false,
      isAudio: 1
    };
  },
  created: function created() {
    // const a = this.$store.getters.currentGame;
    // if (Object.keys(a).length === 0) {
    //   this.$router.push({
    //     path: `/`
    //   });
    // }
    // if (this.user) {
    //   userService.startLesson()
    // }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var lesson;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log(_this.data);
              _this.lessonImage = _this.data.image;
              _this.lessonAudio = _this.data.audio;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_9__services_courseService__["a" /* courseService */].getLessonFromServer(_this.data.id);

            case 5:
              lesson = _context.sent;

              console.log(lesson);
              _this.lessonImage = lesson.image;
              _this.lessonAudio = lesson.audio;
              if (_this.data.audio) _this.isAudio = 0;

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    currentGame: function currentGame() {
      if (this.$store.getters.currentGame) {
        return this.$store.getters.currentGame;
      }
    },
    user: function user() {
      return this.$store.getters.user;
    },
    safeTopVar: function safeTopVar() {
      return { "--top": this.$store.getters.safeTop + "px" };
    },
    safeBottomVar: function safeBottomVar() {
      return { "--bottom": this.$store.getters.safeBottom + "px" };
    }

    // itemList() {
    //   return this.$store.getters.currentGame.lesson.items.sort((a, b) => {
    //     return a.order > b.order ? 1 : -1;
    //   });
    // }

  },
  methods: {
    makeLinkEmbaddable: function makeLinkEmbaddable(link) {
      if (String(link).includes("shorts")) {
        var _youtubeID = String(link).split("/shorts/")[1];
        return "https://www.youtube.com/embed/" + _youtubeID + "?autoplay=" + _this2.isAudio + "&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
      }
      if (String(link).includes(".be/")) {
        var _youtubeID2 = String(link).split(".be/")[1];
        return "https://www.youtube.com/embed/" + _youtubeID2 + "?autoplay=" + _this2.isAudio + "&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
      }
      var youtubeID = String(link).split("watch?v=")[1];
      return "https://www.youtube.com/embed/" + youtubeID + "?autoplay=" + _this2.isAudio + "&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0";
    },
    finishLesson: function finishLesson() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.submitting = true;

                if (!_this3.data) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_userService__["a" /* userService */].finishLesson(_this3.data.id, _this3.user);

              case 4:
                _this3.submitting = false;
                // this.$router.push(`/lesson/${nextLesson.id}`);
                _this3.$router.push("/chapter/");

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },
  components: {
    LessonHeader: __WEBPACK_IMPORTED_MODULE_3__lesson_header_vue___default.a,
    Spacer: __WEBPACK_IMPORTED_MODULE_4__Shared_Spacer_vue___default.a,
    AudioBtn: __WEBPACK_IMPORTED_MODULE_6__Shared_audioBtn_vue___default.a,
    VideoPlayer: __WEBPACK_IMPORTED_MODULE_5__Shared_VideoPlayer_vue___default.a,
    AudioPlayerLesson: __WEBPACK_IMPORTED_MODULE_7__Shared_AudioPlayerLesson_vue___default.a,
    SlinkyVue: __WEBPACK_IMPORTED_MODULE_10__Shared_Slinky_vue___default.a
  }
});

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(463)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(466),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62c62ae1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(464);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("21fcb42a", content, true, {});

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.audio-player-lesson-container[data-v-62c62ae1] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 8px;\n}\n.controls-row[data-v-62c62ae1] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  position: relative;\n  padding: 0;\n}\n.controls-row img[data-v-62c62ae1] {\n  position: absolute;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n.lesson-speed-btn[data-v-62c62ae1] {\n  margin-right: calc(15% - 18px); /* Align with header's 15% right column minus half button width */\n}\n.lesson-speed-btn[data-v-62c62ae1] {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 16px;\n  padding: 4px 8px;\n  font-size: 12px;\n  font-weight: 500;\n  min-width: 36px;\n  height: 24px;\n  cursor: pointer;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  backdrop-filter: blur(4px);\n&:hover {\n    background: rgba(255, 255, 255, 0.3);\n    border-color: rgba(255, 255, 255, 0.5);\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05);\n}\n&:active {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95);\n}\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/AudioPlayerLesson.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,SAAS;CACV;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,0BAA0B;MACtB,uBAAuB;UACnB,+BAA+B;EACvC,mBAAmB;EACnB,WAAW;CACZ;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,oCAAoC;UAC5B,4BAA4B;CACrC;AACD;EACE,+BAA+B,CAAC,kEAAkE;CACnG;AACD;EACE,qCAAqC;EACrC,aAAa;EACb,2CAA2C;EAC3C,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;EAC1B,0BAA0B;KACvB,uBAAuB;MACtB,sBAAsB;UAClB,kBAAkB;EAC1B,2BAA2B;AAC7B;IACI,qCAAqC;IACrC,uCAAuC;IACvC,+BAA+B;YACvB,uBAAuB;CAClC;AACD;IACI,+BAA+B;YACvB,uBAAuB;CAClC;CACA","file":"AudioPlayerLesson.vue","sourcesContent":["\n.audio-player-lesson-container[data-v-62c62ae1] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 8px;\n}\n.controls-row[data-v-62c62ae1] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  position: relative;\n  padding: 0;\n}\n.controls-row img[data-v-62c62ae1] {\n  position: absolute;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n.lesson-speed-btn[data-v-62c62ae1] {\n  margin-right: calc(15% - 18px); /* Align with header's 15% right column minus half button width */\n}\n.lesson-speed-btn[data-v-62c62ae1] {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 16px;\n  padding: 4px 8px;\n  font-size: 12px;\n  font-weight: 500;\n  min-width: 36px;\n  height: 24px;\n  cursor: pointer;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  backdrop-filter: blur(4px);\n&:hover {\n    background: rgba(255, 255, 255, 0.3);\n    border-color: rgba(255, 255, 255, 0.5);\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05);\n}\n&:active {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_audioService__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_settingsService__ = __webpack_require__(209);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AudioPlayer",
  data: function data() {
    return {
      audioFile: null,
      audio: null,
      progressBar: 0,
      isPlaying: null,
      soundSetting: null,
      speakSetting: null,
      playbackRate: 1,
      availableSpeeds: [1, 1.25, 1.5, 2]
    };
  },

  props: {
    urlId: {
      type: String | Number,
      require: false
    },
    hideProgressBar: {
      type: Boolean,
      default: false
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    audioSrc: { type: String, required: true }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__services_settingsService__["a" /* settingsService */].getSettings();

            case 2:
              _this.soundSetting = _context.sent;

              _this.loadSavedSpeed();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    console.log(this.hideProgressBar);
    if (this.urlId) {
      this.getAudio();
    } else {
      this.audioFile = this.audioSrc;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.audio.pause();
  },

  watch: {
    urlId: function urlId() {
      // this.isStop = true;
      this.getAudio();
    },
    audioFile: function audioFile() {
      this.makeAudio(this.audioFile);
    },
    soundSetting: function soundSetting() {
      if (this.soundSetting && this.soundSetting.length) {
        this.speakSetting = this.soundSetting[1];
      }
      if (this.audio && this.autoPlay && this.speakSetting) this.play();
    },
    audio: function audio() {
      console.log(this.speakSetting);
      if (this.autoPlay && this.speakSetting) this.play();
    },
    progressBar: function progressBar() {
      this.$refs.progressBar.style.background = 'linear-gradient(to right, var(--bg-primary) 0%, var(--bg-primary) ' + (this.progressBar - 0) * 100 / (100 - 0) + '%, var(--header-primary) ' + (this.progressBar - 0) * 100 / (100 - 0) + '%, var(--header-primary) 100%)';
      // this.$refs.progressBar.style.backgroundSize =
      //   ((this.progressBar - 0) * 100) / (100 - 0) + "% 100%";
    },
    $route: function $route(to, from) {
      this.audio.pause();
    }
  },
  methods: {
    getAudio: function getAudio() {
      var _this2 = this;

      if (this.urlId) {
        __WEBPACK_IMPORTED_MODULE_3__services_audioService__["a" /* audioService */].playAudio(this.urlId).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
            var _ref2, mediaUrl;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return res.json();

                  case 2:
                    _ref2 = _context2.sent;
                    mediaUrl = _ref2.mediaUrl;

                    _this2.audioFile = mediaUrl;

                    //this.makeAudio(this.audioFile);
                    // if (this.autoplay) {
                    //   this.isStop = false;
                    //   this.playAudio();
                    // }

                  case 5:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, _this2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } else {
        this.audioFile = null;
      }
    },
    changeProgress: function changeProgress(e) {
      if (this.audio) this.audio.currentTime = this.audio.duration / 100 * e.target.value;
      var el = e.target;
      console.log((el.value - 0) * 100 / (100 - 0) + "% 100%");
      el.style.background = 'linear-gradient(to right, var(--bg-primary) 0%, var(--bg-primary) ' + el.value + '%, var(--header-primary) ' + el.value + '%, var(--header-primary) 100%)';
    },
    play: function play(e) {
      console.log(this.audio.paused);
      if (e) e.stopPropagation();
      if (!this.audio.paused) {
        this.audio.pause();
      } else {
        this.audio.play();
      }
    },
    pause: function pause() {
      this.audio.pause();
    },
    makeAudio: function makeAudio(audioFile) {
      var _this3 = this;

      this.audio = new Audio(audioFile);

      this.audio.volume = 0.5;
      this.audio.playbackRate = this.playbackRate;
      this.audio.addEventListener("timeupdate", function (e) {
        _this3.progressBar = _this3.audio.currentTime / _this3.audio.duration * 100;
      });

      this.audio.addEventListener("ended", function () {
        _this3.audio.currentTime = 0;
        _this3.audio.pause();
      });
    },
    cycleSpeed: function cycleSpeed() {
      var currentIndex = this.availableSpeeds.indexOf(this.playbackRate);
      var nextIndex = (currentIndex + 1) % this.availableSpeeds.length;
      this.playbackRate = this.availableSpeeds[nextIndex];

      if (this.audio) {
        this.audio.playbackRate = this.playbackRate;
      }

      // שמירת המהירות ב-localStorage
      localStorage.setItem('audioPlaybackRate', this.playbackRate);
    },
    loadSavedSpeed: function loadSavedSpeed() {
      var savedRate = localStorage.getItem('audioPlaybackRate');
      if (savedRate && this.availableSpeeds.includes(parseFloat(savedRate))) {
        this.playbackRate = parseFloat(savedRate);
      }
    }
  }
});

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audio-player-lesson-container"
  }, [_c('div', {
    staticClass: "controls-row"
  }, [_c('img', {
    class: {
      disabledBtn: !_vm.audioFile
    },
    attrs: {
      "width": _vm.hideProgressBar ? '50px' : '25px',
      "height": _vm.hideProgressBar ? '50px' : '25px',
      "src": _vm.audio && _vm.audio.paused ?
        __webpack_require__(467).default :
        __webpack_require__(468).default
    },
    on: {
      "click": _vm.play
    }
  }), _vm._v(" "), (!_vm.hideProgressBar && _vm.audioFile) ? _c('button', {
    staticClass: "speed-btn lesson-speed-btn",
    attrs: {
      "title": ("מהירות: " + _vm.playbackRate + "x")
    },
    on: {
      "click": _vm.cycleSpeed
    }
  }, [_vm._v("\n      " + _vm._s(_vm.playbackRate) + "x\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', [(!_vm.hideProgressBar) ? _c('input', {
    ref: "progressBar",
    staticClass: "slider",
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "type": "range",
      "name": "progressBar",
      "id": "progressBar"
    },
    domProps: {
      "value": _vm.progressBar
    },
    on: {
      "input": _vm.changeProgress
    }
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDEiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MSA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjM4OTUgMTEuMDQzNEMxMy4zODk1IDkuNDY2NzMgMTUuMDYwNCA4LjQ2MzkgMTYuMzczOSA5LjI1MjI1TDM2LjQ2MzUgMjEuMzA5NUMzNy43NTgyIDIyLjA4NjYgMzcuNzM0NiAyNC4wMjY2IDM2LjQyMDkgMjQuODE1MUwxNi4zMzEzIDM2Ljg3MjRDMTUuMDE3NSAzNy42NjA5IDEzLjM4OTUgMzYuNzEyMSAxMy4zODk1IDM1LjE1OEwxMy4zODk1IDExLjA0MzRaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjkxMTIgMTEuMDY4MkMxMS45MTEyIDguMzA4OTcgMTQuODM1MiA2LjU1NDAxIDE3LjEzMzkgNy45MzM2MkwzNy4yMjM1IDE5Ljk5MDlDMzkuNDg5MiAyMS4zNTA3IDM5LjQ0NzkgMjQuNzQ1OCAzNy4xNDg5IDI2LjEyNTdMMTcuMDU5MyAzOC4xODI5QzE0Ljc2MDIgMzkuNTYyOCAxMS45MTEyIDM3LjkwMjQgMTEuOTExMiAzNS4xODI4TDExLjkxMTIgMTEuMDY4MlpNMTUuNjEzMyAxMC41NjkzQzE1LjI4NSAxMC4zNzIyIDE0Ljg2NzIgMTAuNjIyOSAxNC44NjcyIDExLjAxNzFMMTQuODY3MiAzNS4xMzE3QzE0Ljg2NzIgMzUuNTIwMiAxNS4yNzQyIDM1Ljc1NzQgMTUuNjAyNyAzNS41NjAzTDM1LjY5MjMgMjMuNTAzQzM2LjAyMDcgMjMuMzA1OSAzNi4wMjY2IDIyLjgyMDkgMzUuNzAyOSAyMi42MjY2TDE1LjYxMzMgMTAuNTY5M1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAxNyAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC43MDg5ODQiIHdpZHRoPSI1Ljc3MTgxIiBoZWlnaHQ9IjI1IiByeD0iMi44ODU5MSIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iMTAuMzI5MSIgd2lkdGg9IjUuNzcxODEiIGhlaWdodD0iMjUiIHJ4PSIyLjg4NTkxIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lesson-page"
  }, [_c('LessonHeader', {
    staticClass: "LesonTop",
    style: (_vm.safeTopVar),
    attrs: {
      "currentData": _vm.data
    }
  }), _vm._v(" "), (!_vm.data) ? _c('div', {
    staticClass: "loader"
  }, [_vm._v("\n    " + _vm._s(_vm.$t("lesson.lesson-page.loading")) + "\n    "), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "center",
      "margin": "8px"
    }
  }, [_c('SlinkyVue')], 1)]) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('div', {
    staticClass: "centered"
  }, [_c('div', {
    staticClass: "lesson-player"
  }, [(_vm.data.text) ? _c('div', {
    staticStyle: {
      "padding-bottom": "0.5em"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.data.text) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.lessonAudio) ? _c('div', [_c('AudioPlayerLesson', {
    attrs: {
      "audioSrc": _vm.lessonAudio,
      "height": 25,
      "autoPlay": true
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.lessonImage) ? _c('div', [_c('div', [_c('img', {
    attrs: {
      "src": _vm.lessonImage
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.data.video) ? _c('div', [_c('div', [_c('VideoPlayer', {
    attrs: {
      "vidSrc": _vm.makeLinkEmbaddable(_vm.data.video)
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "75px",
      "width": "100%"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions-wrapper"
  }, [_c('button', {
    staticClass: "lesson-approve",
    style: (_vm.safeBottomVar),
    on: {
      "click": _vm.finishLesson
    }
  }, [_vm._v("\n      " + _vm._s(_vm.submitting ?
    _vm.$t("lesson.lesson-page.loading2") :
    _vm.$t("lesson.lesson-page.continue")) + "\n    ")])])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 8.ce03fd3d81a126f24b18.bundle.js